import script from "./ProfilePasswordResetStepOnePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfilePasswordResetStepOnePage.vue?vue&type=script&setup=true&lang=ts"

import "./ProfilePasswordResetStepOnePage.vue?vue&type=style&index=0&id=5d9629ea&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d9629ea"]])

export default __exports__